module.exports = __webpack_public_path__ + "img/logo.097091a8.svg";